var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiRrArrowRightToBracket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.33333V12.6667C16 14.5067 14.5067 16 12.6667 16H10.6667C10.3 16 10 15.7 10 15.3333C10 14.9667 10.3 14.6667 10.6667 14.6667H12.6667C13.7667 14.6667 14.6667 13.7667 14.6667 12.6667V3.33333C14.6667 2.23333 13.7667 1.33333 12.6667 1.33333H10.6667C10.3 1.33333 10 1.03333 10 0.666667C10 0.3 10.3 0 10.6667 0H12.6667C14.5067 0 16 1.49333 16 3.33333ZM12 8C12 7.46667 11.7933 6.96667 11.42 6.59333L8.48 3.53333C8.22667 3.26667 7.8 3.26 7.54 3.51333C7.27333 3.76667 7.26667 4.19333 7.52 4.45333L10.2867 7.32667H0.666667C0.3 7.32667 0 7.62667 0 7.99333C0 8.36 0.3 8.66 0.666667 8.66H10.28L7.51333 11.5333C7.26 11.8 7.26667 12.22 7.53333 12.4733C7.66 12.6 7.82667 12.66 7.99333 12.66C8.16667 12.66 8.34 12.5933 8.47333 12.4533L11.4067 9.40667C11.7867 9.02667 11.9933 8.52667 11.9933 7.99333L12 8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrArrowRightToBracket);
export default __webpack_public_path__ + "static/media/fi-rr-arrow-right-to-bracket.c10062ddca32e85f34bc18c3da648cd5.svg";
export { ForwardRef as ReactComponent };